import { I18n } from '@aws-amplify/core';
import type { ReportType } from '@/types/DataExtraction';
import type {
	DataExtractionReportItem,
	DataExtractionData,
	CustomReport
} from '@/components/Settings/DataExtraction/types';
import { TOOL_CONFIGS } from '@/components/Settings/DataExtraction/ExtractionType/Hierarchy/Steps/Tools/Form/Icons';

export const getReportId = (report: DataExtractionReportItem): string | null => {
	const options = {
		bera_report: report.bera_report_id,
		sera_report: report.sera_report_id,
		custom_report: report.custom_report_id
	};

	return options[report.report_type] || null;
};

const getReportTypeFromName = (name: string): ReportType => {
	const options = {
		bera: 'bera_report',
		sera: 'sera_report',
		custom_report: 'custom_report'
	} as const;

	return name in options ? options[name as keyof typeof options] : 'custom_report';
};

export function getReportCategory(dataExtractionReport: DataExtractionData): ReportType {
	const reportName = dataExtractionReport?.custom_report?.name ?? '';
	return getReportTypeFromName(reportName);
}

export const buildReportsPayload = (
	customReportTypeId: string,
	customReports: CustomReport[],
	selectedReports: string[] = []
): DataExtractionReportItem[] => {
	const selectedCustomReport = customReports.find((report) => report.id === customReportTypeId);
	const reportType = getReportTypeFromName(selectedCustomReport?.name ?? '');

	return selectedReports.map((reportId: string) => ({
		report_type: reportType,
		bera_report_id: reportType === 'bera_report' ? reportId : null,
		sera_report_id: reportType === 'sera_report' ? reportId : null,
		custom_report_id: reportType === 'custom_report' ? reportId : null
	}));
};

export const mapToFormInitialValues = (data: DataExtractionData) => {
	return {
		reports: {
			custom_report_type_id: data.custom_report_id,
			selected_reports: data.data_extraction_reports?.map(getReportId).filter(Boolean) || [],
			has_action_plan_extraction: Boolean(data.has_action_plan_extraction)
		}
	};
};

export function getFormattedToolName(toolName: string): string {
	const config = TOOL_CONFIGS[toolName];
	return config ? I18n.get(config.label) : toolName.toUpperCase();
}
